import { ResponsiveUtils } from "@/shared/utils/responsive/responsive-utils";
import $ from "jquery";

export class Footer {
    private _element: JQuery;
    private inited: boolean;

    constructor(element: JQuery) {
        this._element = element;
        this.inited = false;

        $(window).resize(this.initFooter);
        this.initFooter();
    }

    private initFooter = () => {
        if (ResponsiveUtils.breakpointUp("sm1")) {
            $(".footer__list").slideDown();
            $(".footer__list").removeClass("expanded");
        } else {
            if (this.inited) return false;
            $(".footer__title").click(function () {
                if (!$(this).hasClass("expanded")) {
                    $(this).addClass("expanded");
                    $(this).parent().find(".footer__list").slideDown();
                } else {
                    $(this).removeClass("expanded");
                    $(this).parent().find(".footer__list").slideUp();
                }
            });
            this.inited = true;
        }
    };

    public static init() {
        const elems = $(".footer");
        elems.each((index, elem) => {
            new Footer($(elem));
        });
    }
}
